import { AthleteOverviewSponsorBannerProps } from "@/components/athlete-overview-page/sponsor-banner/types";
import { UseAthleteOverview } from "@/components/athlete-overview-page/athlete-overview-page-provider";

export type { AthleteOverviewSponsorBannerProps };

export function AthleteOverviewSponsorBanner() {
    const { data } = UseAthleteOverview();
    const { sponsorBanner } = data;

    if (!sponsorBanner?.imageUrl) return null;

    return (
        <a href={sponsorBanner.imageLink} className=" w-full">
            <img
                src={sponsorBanner.imageUrl}
                alt={sponsorBanner.imageAltText}
                className=" object-cover object-center w-full"
            />
        </a>
    )
}